import { useState } from "react"

import { SearchInput } from "@/components/ui/search-input"

export function SearchInputPreviewRoute(): JSX.Element {
  const [v, setV] = useState("")
  const [sm, setSm] = useState("")

  return (
    <div className="mx-auto max-w-2xl px-8.5 py-11">
      <header className="mb-8">
        <div className="font-id text-eyebrow uppercase tracking-[0.16em] text-text-3">
          Primitive
        </div>
        <h1 className="mt-1 text-display text-text">SearchInput</h1>
      </header>

      <div className="space-y-6">
        <div>
          <div className="mb-2 font-id text-caption uppercase tracking-[0.16em] text-text-3">
            Default (34px)
          </div>
          <SearchInput
            aria-label="Search reviews"
            placeholder="Search reviews…"
            value={v}
            onChange={(e) => {
              setV(e.target.value)
            }}
            onClear={() => {
              setV("")
            }}
          />
        </div>

        <div>
          <div className="mb-2 font-id text-caption uppercase tracking-[0.16em] text-text-3">
            Small (28px, inside table headers)
          </div>
          <SearchInput
            aria-label="Filter rows"
            size="sm"
            placeholder="Filter…"
            value={sm}
            onChange={(e) => {
              setSm(e.target.value)
            }}
            onClear={() => {
              setSm("")
            }}
          />
        </div>
      </div>
    </div>
  )
}
